module.exports = __webpack_public_path__ + "static/image/history/pc/201908.jpg?b0121369";